import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { WindowToken } from "@app/util/window.token";

@Component({
    template: require('./registrationDialogAltAddress.html')
})
export class RegistrationAltAddressDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationAltAddressDialog>) public dialogRef: MatDialogRef<RegistrationAltAddressDialog>,
                @Inject(WindowToken) public window) {}

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

    openUrl(url) {
        this.window.open(url, '_blank');
    }

}
